import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ITablePagination } from 'src/app/models';
import { MouldLogEntryAdapter } from 'src/app/models/domain/adapters';
import { EntriesService, EntryFilterContract } from 'src/generated-clients/mould_log';

@Injectable({
  providedIn: 'root',
})
export class MouldLogDataService {
  public constructor(
    private readonly mouldLogApi: EntriesService,
    private readonly mouldLogEntryAdapter: MouldLogEntryAdapter
  ) {}

  public loadMouldLogPage(
    pagination: ITablePagination,
    equipmentNumber: string,
    entryCodes?: string[]
  ) {
    const offset = (pagination.page - 1) * pagination.perPage;
    const limit = pagination.perPage;

    const filter: EntryFilterContract = {
      codes: entryCodes,
    };

    return this.mouldLogApi
      .v1MouldsMouldIdLogEntriesGet(equipmentNumber, filter, offset, limit)
      .pipe(
        map((response) => ({
          data:
            response.value?.map((entry) => this.mouldLogEntryAdapter.adaptToDomain(entry)) ?? [],
          total: response.total ?? response.value?.length ?? 0,
        }))
      );
  }
}
